export default __webpack_public_path__ + "static/media/blue-loader.537dc03d.svg";